import { Outlet } from "react-router-dom";

function AuthLayout() {
  return (
    <div className="md:flex h-screen overflow-hidden">
      <div className="md:block hidden w-1/2 bg-gradient-to-r from-purple-900 to-purple-500"></div>
      <div className="md:w-1/2 bg-purple-500 h-full">
        <div className="relative bg-white md:rounded-l-2xl h-full overflow-y-auto shadow-xl">
          <div className="absolute top-8 left-10 text-xl  text-gray-700">
            Status Application
          </div>

          <div className="flex justify-center items-center h-full">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
